/*
  if (typeof jQuery == 'undefined') {
console.log("Jquery not available");
}
else{
console.log('Jquery Ver:' + jQuery.fn.jquery);
}

$(window).on('load', function () { alert("Window Loaded"); });
*/


 (function($){
    $(function(){  //document.ready
        //DOM READY code here
        //console.log('Jquery Loaded Ver:' + jQuery.fn.jquery);
        //one: const el = document.querySelectorAll("[data-coupon-copy-button]");
        // all
       const arrFiltered = document.querySelectorAll("[data-coupon-copy-button]");
       arrFiltered.forEach(function (el){ 
         el.addEventListener("click", couponCopyClick, false);
        });

    });
/////////// end dom ready


   
    //Functions, Plugins (does not wait for DOM READY STATE)
      
      function couponCopyClick(event) {
        event.preventDefault();
        var coupon_code = this.getAttribute("data-coupon-code");
        var redirect_url = this.getAttribute("data-redirect-url");
        copyTextToClipboard(coupon_code);
        //alert("coupon clicked " + this.getAttribute("data-redirect-url"));

         this.classList.add( "copied" );
         var el = this;
    
          var temp = setInterval( function(){
            el.classList.remove( "copied" );
            clearInterval(temp);

              if(redirect_url !== "#") {
                window.location.href = redirect_url;
              }
            //document.cookie = "copied_coupon_code=coupon_code; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/";
            //document.cookie = "user_did_copy=true; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/";
          }, 750 );

      

        
        // $(event).data('redirect-url').value()
      }
   
        function fallbackCopyTextToClipboard(text) {
          var textArea = document.createElement("textarea");
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          try {
            var successful = document.execCommand("copy");
            var msg = successful ? "successful" : "unsuccessful";
            //console.log("Fallback: Copying text command was " + msg);
          } catch (err) {
            //console.error("Fallback: Oops, unable to copy", err);
          }
          document.body.removeChild(textArea);
        }
           
        function copyTextToClipboard(text) {
          if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
            return;
          }
          navigator.clipboard.writeText(text).then(
            function() {
              console.log("Async: coupon copied");
            },
            function(err) {
              console.error("Async: Could not copy coupon: ", err);
            }
          );
        }  
    //////////////////// end func
   

})(jQuery);